import { Injectable } from '@angular/core';
import { isNullOrEmpty } from '../utils/common-functions';

/**
 * 畫面元素控制設定服務
 *
 * @export
 * @class ElementControlService
 */
@Injectable({
  providedIn: 'root',
})
export class ElementControlService {
  static elementControlConfig: any = {};

  constructor() {}

  /**
   * 是否有該元素控制設定
   *
   * @param {string} category 分類
   * @param {string} elementId 元素 ID
   * @return {*}  {boolean}
   * @memberof ElementControlService
   */
  checkIsUnderControl(category: string, elementId: string): boolean {
    if (isNullOrEmpty(category) === false) {
      if (
        isNullOrEmpty(ElementControlService.elementControlConfig) === false &&
        ElementControlService.elementControlConfig.hasOwnProperty(category)
      ) {
        const config = ElementControlService.elementControlConfig[category];
        if (
          config.hasOwnProperty(elementId) &&
          config[elementId].display === true
        ) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * 取得元素控制設定
   *
   * @param {string} category 分類
   * @param {string} elementId 元素 ID
   * @return {*}  {*}
   * @memberof ElementControlService
   */
  getControlItem(category: string, elementId: string): any {
    if (this.checkIsUnderControl(category, elementId)) {
      const item =
        ElementControlService.elementControlConfig[category][elementId];
      return item;
    }
    return null;
  }

  /**
   * 是否有該元素控制設定
   *
   * @param {string} category 分類
   * @param {string} elementId 元素 ID
   * @return {*}  {boolean}
   * @memberof ElementControlService
   */
  existElementControl(category: string, elementId: string): boolean {
    if (isNullOrEmpty(category) === false) {
      if (
        isNullOrEmpty(ElementControlService.elementControlConfig) === false &&
        ElementControlService.elementControlConfig.hasOwnProperty(category)
      ) {
        const config = ElementControlService.elementControlConfig[category];
        if (config.hasOwnProperty(elementId)) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * 取得元素控制設定(不會有 null 的情境)
   * 若無設定則 hidden 皆 return false
   *
   * @param {string} category 分類
   * @param {string} elementId 元素 ID
   * @return {*}  {*}
   * @memberof ElementControlService
   */
  getControlItemForTableHidden(category: string, elementId: string): boolean {
    let hidden = false;
    if (this.existElementControl(category, elementId)) {
      const display =
        ElementControlService.elementControlConfig[category][elementId];
      hidden = display === true ? false : true;
    }
    return hidden;
  }
}
